import {
  AvailableSubscriptionsResponse,
  DowngradeSubscriptionDto,
  SetBackupSubscriptionDto,
  UpgradeSubscriptionDto,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function getAvailableSubscriptions(): Promise<AvailableSubscriptionsResponse> {
  return httpClient.get('subscriptions').json();
}

export async function sendDowngradeFormula(request: DowngradeSubscriptionDto): Promise<void> {
  return httpClient.post('subscriptions/downgrade-package', { json: request }).json();
}

export async function sendUpgradeFormula(request: UpgradeSubscriptionDto): Promise<void> {
  return httpClient.post('subscriptions/upgrade-package', { json: request }).json();
}

export async function setBackupFormula(request: SetBackupSubscriptionDto): Promise<void> {
  return httpClient.post('subscriptions/backup-package', { json: request }).json();
}
